import React, { useMemo } from "react";
import { Container, TextContainer } from "./catalog-list.styled";
import { useMainPageContext } from "@/contexts/MainPageContext";
import { filterProducts } from "@/helper/filterProducts";
import CatalogListDropdown from "./catalog-list-dropdown";
const MAX_UNTRUNCATED_ITEMS = 6;
export default function CatalogList({ catalogNameList, selectedCatalogIndex, setSelectedCatalogIndex }) {
    const { catalogList, filterProductInputValue, selectedLetter, categoriesSelected } = useMainPageContext();
    const itemsCountPerCatalog = useMemo(() => {
        return catalogList.reduce((counts, catalog, index) => {
            const itemsCount = filterProducts(
                catalog.items,
                categoriesSelected,
                filterProductInputValue,
                selectedLetter,
            ).length;
            counts[index] = itemsCount;
            return counts;
        }, {});
    }, [filterProductInputValue, catalogList, categoriesSelected, selectedLetter]);

    const catalogNameListIndexes = useMemo(() => {
        const indexes = new Map();
        catalogNameList.forEach((name, index) => {
            indexes.set(name, index);
        });
        return indexes;
    }, [catalogNameList]);

    const displayedCatalogNames = useMemo(() => {
        if (!catalogNameList || catalogNameList.length === 0) return [];
        const firstSix = catalogNameList.slice(0, MAX_UNTRUNCATED_ITEMS);
        if (firstSix.includes(catalogNameList[selectedCatalogIndex])) {
            return firstSix;
        }
        const selected = catalogNameList[selectedCatalogIndex];
        const firstFive = catalogNameList
            .filter((_, idx) => idx !== selectedCatalogIndex)
            .slice(0, MAX_UNTRUNCATED_ITEMS - 1);

        return [selected, ...firstFive];
    }, [catalogNameList, selectedCatalogIndex]);

    return (
        <Container>
            {displayedCatalogNames.map((catalogName) => {
                const index = catalogNameListIndexes.get(catalogName);
                return (
                    <TextContainer
                        key={catalogName}
                        selected={index === selectedCatalogIndex}
                        disabled={itemsCountPerCatalog[index] === 0}
                        onClick={() => setSelectedCatalogIndex(index)}
                    >
                        {catalogName}
                    </TextContainer>
                );
            })}
            {catalogNameList.length > MAX_UNTRUNCATED_ITEMS && (
                <CatalogListDropdown
                    items={catalogNameList}
                    selectedIndex={selectedCatalogIndex}
                    itemsCountPerCatalog={itemsCountPerCatalog}
                    onClick={setSelectedCatalogIndex}
                />
            )}
        </Container>
    );
}
